import { EEOKind } from '../eeo/eeo.types';
import { BillingPlanTier } from '../products/products.types';

export enum FeatureCode {
  AdjustableRoles = 'adjustable_roles',
  CandidateAnonymization = 'candidate_anonymization',
  CustomisableReports = 'customisable_reports',
  AuditLogs = 'audit_logs',
  AutomatedActions = 'automated_actions',
  CustomDomain = 'custom_domain',
  DefaultProfileFields = 'default_profile_fields',
  EEO = 'eeo',
  EvaluationForms = 'evaluation_forms',
  FairEvaluations = 'fair_evaluations',
  GDPRAutomations = 'gdpr_automations',
  JobScheduler = 'job_scheduler',
  KnockoutQuestions = 'knockout_questions',
  Locations = 'locations',
  MeetingRooms = 'meeting_rooms',
  Multilang = 'multilang',
  NotificationsPerRole = 'notifications_per_role',
  OpenQuestions = 'open_questions',
  OverdueCandidates = 'overdue_candidates',
  Pipelines = 'pipelines',
  ProfilePrint = 'profile_print',
  Questionnaires = 'questionnaires',
  Referrals = 'referrals',
  Requisitions = 'requisitions',
  Scheduler = 'scheduler',
  Security = 'security',
  SendLater = 'send_later',
  SourcingExtension = 'sourcing_extension',
  SSO = 'sso',
  Visibility = 'visibility',
  Webhooks = 'webhooks',
}

type Base = {
  enabled: boolean;
  entitled: boolean;
  availableFrom: BillingPlanTier | null;
};

type EmptyConfig = {};

export type LocationsConfig = {
  limit: number | null;
};

export type EEOConfig = {
  dataRetentionDays: number;
  emailBodyHtml: string;
  emailSubject: string;
  kind: EEOKind;
};

export type ConfigsMap = {
  [FeatureCode.AdjustableRoles]: EmptyConfig;
  [FeatureCode.CandidateAnonymization]: EmptyConfig;
  [FeatureCode.CustomisableReports]: EmptyConfig;
  [FeatureCode.AuditLogs]: EmptyConfig;
  [FeatureCode.AutomatedActions]: EmptyConfig;
  [FeatureCode.CustomDomain]: EmptyConfig;
  [FeatureCode.DefaultProfileFields]: EmptyConfig;
  [FeatureCode.EEO]: EEOConfig;
  [FeatureCode.EvaluationForms]: EmptyConfig;
  [FeatureCode.FairEvaluations]: EmptyConfig;
  [FeatureCode.GDPRAutomations]: EmptyConfig;
  [FeatureCode.JobScheduler]: EmptyConfig;
  [FeatureCode.KnockoutQuestions]: EmptyConfig;
  [FeatureCode.Locations]: LocationsConfig;
  [FeatureCode.MeetingRooms]: EmptyConfig;
  [FeatureCode.Multilang]: EmptyConfig;
  [FeatureCode.NotificationsPerRole]: EmptyConfig;
  [FeatureCode.OpenQuestions]: EmptyConfig;
  [FeatureCode.OverdueCandidates]: EmptyConfig;
  [FeatureCode.Pipelines]: EmptyConfig;
  [FeatureCode.ProfilePrint]: EmptyConfig;
  [FeatureCode.Questionnaires]: EmptyConfig;
  [FeatureCode.Referrals]: EmptyConfig;
  [FeatureCode.Requisitions]: EmptyConfig;
  [FeatureCode.SSO]: EmptyConfig;
  [FeatureCode.Scheduler]: EmptyConfig;
  [FeatureCode.Security]: EmptyConfig;
  [FeatureCode.SendLater]: EmptyConfig;
  [FeatureCode.SourcingExtension]: EmptyConfig;
  [FeatureCode.Visibility]: EmptyConfig;
  [FeatureCode.Webhooks]: EmptyConfig;
};

export type FeatureSpec = {
  codename: FeatureCode;
  configuration: ConfigsMap[FeatureCode];
} & Base;
